// ModalContext.js
import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [game, setGame] = useState(null);

  const openModal = (gameData) => {
    setGame(gameData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setGame(null);
  };

  return (
    <ModalContext.Provider value={{ isOpen, game, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
